import AddressDetail from './AddressDetail';

const routes = [
  {
    path: ':address',
    element: <AddressDetail />,
  },
];

export default routes;
export { AddressDetail };
